module.exports = __webpack_public_path__ + "img/2.19947398.png";